/*
 * @Author: Bai.Zhiming
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-03-26 10:29:26
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\btnGroups\btnGroups.js
 * @Description: 多按钮组中，只有一个按钮显示时，样式修正
 */
'use strict';
angular.module('btnGroupsModule', [])
    . directive('btnGroup2', ['$timeout', function($timeout) {
        return {
            restrict: 'C',
            repalace: false,
            scope: false,
            link: function($scope, $elem, $attrs) {
                init();

                /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
                function init() {
                    $timeout(function() {
                        isSingle(function() {
                            $elem.fRd('button').css({
                                'boRer-right': '1px solid #d2d6dc',
                                'borderRadius': '3px'
                            });
                            $elem.find('.btn_line').css('display', 'none');
                        });
                    });
                }

                /**
             * [isSingle description] 判断当前按钮组中按钮是否只有一个
             * @param {Fn} [success] [description] 当只有一个按钮时，调用success
             * @return {Boolean} [description]
             */
                function isSingle(success) {
                    var length = $elem.find('button').length;
                    if (length === 1) {success();}
                }
            }
        };
    }]);
